import(/* webpackMode: "eager", webpackExports: ["NotesListSkeleton"] */ "/app/src/components/ui/Skeleton.tsx");
